<template>
  <div class="c-zones-settings">
    <settings-header title="Параметры слоя" />
    <div class="c-zones-settings__container">
      <color-control
        :id="id"
        :config="stylesConfigs.style.paint"
        color-field="fill-color"
        opacity-field="fill-opacity"
      />
      <outline-control
        :id="id"
        type="zones"
        :config="stylesConfigs.borderStyle.paint"
        color-field="line-color"
        opacity-field="line-opacity"
        width-field="line-width"
      />
      <popup-control :id="id" />
    </div>
  </div>
</template>

<script>
import SettingsHeader from "../../settings-header/settings-header";
import ColorControl from "../controls/color";
import OutlineControl from "../controls/outline";
import PopupControl from "../controls/popup";

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    SettingsHeader,
    ColorControl,
    PopupControl,
    OutlineControl
  },
  computed: {
    stylesConfigs() {
      return this.$store.state.calculations.stylesConfigs[this.id];
    }
  }
};
</script>

<style lang="scss">
.c-zones-settings {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__container {
    flex: 1;
    height: 0px;
    padding: 8px;
  }
}
</style>
